import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { EstadoResultadosService } from './estado-resultados.service';
import { LoginService } from '../../../login/login.service';
import { ReporteService } from '../reporte.service';
import * as FileSaver from 'file-saver';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

import { PeriodoEjercicioService } from '../../../control/periodo.service';
declare const require: any;
const {jsPDF} = require('jspdf');
@Component({
  selector: 'app-estado-resultados',
  templateUrl: './estado-resultados.component.html',
  styleUrls: ['./estado-resultados.component.css'],
  providers: [ReporteService]
})
export class EstadoResultadosComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  public anos: any[] = [];
  public list: any[] = [];
  public ano: number;
  public reportePeriodos: boolean;
  public mes: number;
  public reporte: any = undefined;
  public reporte2: any[] = [];
  public empresa: String = this.loginService.usuario.empresa_seleccionada.titulo;
  public columnaTitulo: number;
  cargado: boolean;
  public meses: any[] = [
  {numero: 1 , nombre: 'enero'},
  {numero: 2, nombre: 'febrero'},
  {numero: 3, nombre: 'marzo'},
  {numero: 4, nombre: 'abril'},
  {numero: 5, nombre: 'mayo'},
  {numero: 6, nombre: 'junio'},
  {numero: 7, nombre: 'julio'},
  {numero: 8, nombre: 'agosto'},
  {numero: 9, nombre: 'septiembre'},
  {numero: 10, nombre: 'octubre'},
  {numero: 11, nombre: 'noviembre'},
  {numero: 12, nombre: 'diciembre'},
  {numero: 13, nombre: 'periodo_ajuste'}];
  constructor(private service: ReporteService, private loginService: LoginService, private PeriodoEjercicioService: PeriodoEjercicioService) {

  }
  exportAsPDF() {
    const totalPagesExp = 1;
    this.list = [];
    const tab_temporal = this.reporte2;
    this.reporte2 = [];
    for (const item of tab_temporal) {
      this.reporte2.push(item);
      if (item.estilo === 'titulo' && item.cantidad != null) {
        this.reporte2.push({ titulo: ' ', cantidad: null, estilo: 'titulo' });
      }
    }
    const doc = new jsPDF('landscape');
    const indicesTitulos = [];
    for (const item of this.reporte2) {
      const datos = [];
      if ((item.estilo && !item.cantidad) || (item.estilo && item.cantidad)) {
        item.titulo = item.titulo.toUpperCase();
      }
      datos.push(item.titulo);
      if (item.cantidad) {
        for (const item2 of item.cantidad) {
          datos.push(item2);
        }
      }
      this.list.push(datos);
      if ((item.estilo && !item.cantidad) || (item.estilo && item.cantidad)) {
        indicesTitulos.push(this.list.length - 1);
      }
    }
    this.reporte2 = tab_temporal;
    doc.setProperties({ title: 'ESTADO DE RESULTADOS' });
    // Or use javascript directly:
    const titulos = [];
    titulos.push('Titulo');
    for (const item of this.reporte.reporte) {
      titulos.push(item.mesNombre);
    }
    titulos.push('Total');
    titulos.push('%');
    doc.autoTable({
      columnStyles: { europe: { halign: 'center' } },
      head: [titulos],
      body: this.list,
      didParseCell: function(data) {
        for (const item of indicesTitulos) {
          if (data.row.index === item) {
            data.cell.styles.fontStyle = 'bold';
          }
        }
        if (data.column.dataKey === 1 || data.column.dataKey === 2
          || data.column.dataKey === 3 || data.column.dataKey === 4
          || data.column.dataKey === 5 || data.column.dataKey === 6
          || data.column.dataKey === 7 || data.column.dataKey === 8
          || data.column.dataKey === 9 || data.column.dataKey === 10
          || data.column.dataKey === 11 || data.column.dataKey === 12
          || data.column.dataKey === 13 || data.column.dataKey === 14) {
          data.cell.styles.halign = 'right';
        }
      },
      /*whatever you write in didDrawPage comes in every page. Header or footer is determined from startY position in the functions.*/
      didDrawPage: function(data) {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();

        const hoy = dd + '/' + mm + '/' + yyyy;

        doc.setFont('Condensed');
      //   doc.setFontType('Bahnschrift');
        doc.setFontSize(12);
        let fileTitle = localStorage.getItem('empresa_nombre');
        doc.text(fileTitle, 14, 20);

        doc.setFont('Condensed');
        //doc.setFontType('Bahnschrift');
        doc.setFontSize(18);
        fileTitle = 'CONTABILIDAD';
        doc.text(fileTitle, 14, 15);

        doc.setFont('Light');
        //doc.setFontType('Calibri');
        doc.setFontSize(14);
        fileTitle = 'ESTADO DE RESULTADOS';
        doc.text(fileTitle, 112, 30);

        doc.setFont('Condensed');
        //doc.setFontType('Bahnschrift');
        doc.setFontSize(12);
        doc.text('Fecha: ' + hoy, 250, 20);

        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        let str = 'Pagina ' + doc.internal.getNumberOfPages()
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + '                                                                                                                                                                                                                                                                                ' + hoy;

        }
        doc.setFontSize(10);
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      },
      margin: {
        bottom: 60,
        top: 40
      }
    });
    const finalY = doc.previousAutoTable.finalY;
    doc.save('Reporte_estado_resultados' + '_' + (this.mes==13?'periodo_ajuste':this.meses[this.mes-1].nombre) + '_' + this.ano + '.pdf');
  }
  colspanLength() {
    if (this.reportePeriodos === true) {
      this.columnaTitulo = 4;
    } else {
      this.columnaTitulo = this.mes + 3;
    }
  }
  ngOnInit(): void {
    this.reporte = [];
    this.columnaTitulo = 4;
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.mes = periodo ? periodo : 13;
      });
    this.reportePeriodos = true;
    this.cargarAno();
    this.colspanLength();
  }
  toogle(check: boolean) {
    this.reportePeriodos = check;
    this.cargarDatos();
  }
  cargarAno() {
    const ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
    this.ano = this.loginService.ejercicio;

         this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.ano = ejercicio ? ejercicio : 0;

    });
    this.cargarDatos();
  }
  generarReporteLogico() {
    this.reporte2 = [];
    let cuenta = 0;
    for (let x = 0; x < this.reporte.reporte.length; x++) {
      this.reporte.reporte[x].total = 0;
      cuenta = 0;
      for (let y = 0; y < this.reporte.reporte[x].estadoMes.length; y++) {
        if (x == 0) {
          this.reporte2.push({ titulo: this.reporte.reporte[x].estadoMes[y].titulo, cantidad: null, estilo: 'titulo' });
        }
        cuenta += 1;
        for (let z = 0; z < this.reporte.reporte[x].estadoMes[y].body.length; z++) {
          cuenta += 1;
          if (x == 0) {
            this.reporte2.push({
              titulo: this.reporte.reporte[x].estadoMes[y].body[z].nombre,
              cantidad: []
            });
            this.reporte2[this.reporte2.length - 1].cantidad.push(this.reporte.reporte[x].estadoMes[y].body[z].periodo);
          } else {
            this.reporte2[cuenta - 1].cantidad.push(this.reporte.reporte[x].estadoMes[y].body[z].periodo);
          }

        }
        cuenta += 1;
        if (x == 0) {
          this.reporte2.push({
            titulo: 'Total ' + this.reporte.reporte[x].estadoMes[y].titulo, cantidad: [], estilo: 'titulo',
            tipo: 'total'
          });
          this.reporte2[this.reporte2.length - 1].cantidad.push(this.reporte.reporte[x].estadoMes[y].total);
        } else {
          this.reporte2[cuenta - 1].cantidad.push(this.reporte.reporte[x].estadoMes[y].total);
        }
        this.reporte.reporte[x].total += this.reporte.reporte[x].estadoMes[y].total;
      }
      cuenta += 1;
      if (x == 0) {
        this.reporte2.push({ titulo: 'UTILIDAD ', cantidad: [], estilo: 'titulo' });
        this.reporte2[this.reporte2.length - 1].cantidad.push(this.reporte.reporte[x].cantidadMes);
      } else {
        this.reporte2[cuenta - 1].cantidad.push(this.reporte.reporte[x].cantidadMes);
      }
    }
    for (let x = 0; x < this.reporte2.length; x++) {
      if (this.reporte2[x].cantidad != null) {
        let cantidad = 0;
        for (let y = 0; y < this.reporte2[x].cantidad.length; y++) {
          cantidad += this.reporte2[x].cantidad[y];
        }
        this.reporte2[x].cantidad.push(cantidad);
      }
    }
    for (let x = 0; x < this.reporte2.length; x++) {
      if (this.reporte2[x].cantidad != null) {
        let total = this.reporte2[x].cantidad[this.reporte2[x].cantidad.length - 1];
        for (let y = x; y < this.reporte2.length; y++) {
          if (this.reporte2[y].tipo) {
            if (total > 0 || this.reporte2[y].cantidad[this.reporte2[y].cantidad.length - 1] > 0) {
              this.reporte2[x].cantidad.push((total * 100) / this.reporte2[y].cantidad[this.reporte2[y].cantidad.length - 1]);
            } else {
              this.reporte2[x].cantidad.push(0);
            }
            break;
          }
        }
      }
    }
  }
  cargarDatos() {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    let mesIni = 1;
    if (this.reportePeriodos == true) {
      mesIni = this.mes;
    }
    this.service.getRepEstRes(this.loginService.empresa, mesIni, this.mes, this.ano).subscribe(
      response => {
        this.reporte = response.contenido;
        this.generarReporteLogico();
        this.colspanLength();
        this.cerrarMensajeCarga();
      }, err => {
        this.cerrarMensajeCarga();
      }
    );
  }
  exportAsXLSX(tableID, filename = '') {
    let anchoMaximo = 0;
    const tab_temporal = this.reporte2;
    this.reporte2 = [];
    for (const item of tab_temporal) {
      this.reporte2.push(item);
      if (item.estilo === 'titulo' && item.cantidad != null) {
        this.reporte2.push({ titulo: ' ', cantidad: null, estilo: 'titulo' });
      }
      if (item.titulo.length > anchoMaximo) {
        anchoMaximo = item.titulo.length;
      }
    }
    this.delay(10).then(any => {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
      this.reporte2 = tab_temporal;
      ws['!cols'] = [{ width: anchoMaximo }];
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');
      /* save to file */
      XLSX.writeFile(wb, 'Reporte_estado_resultados' + '_' + (this.mes==13?'periodo_ajuste':this.meses[this.mes-1].nombre) + '_' + this.ano + '.xlsx');
    });

  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log("fired"));
  }
  mostrarMensajeCarga(mensaje: string) {
    this.cargado = false;
    const numeros = [1, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
    const aleatorio = numeros[Math.floor(Math.random() * numeros.length)];
    Swal.fire({
      html: `
      <div style="text-align: center">
        <h4><img src="/assets/gif/loading` + aleatorio + `.gif" width="80"/>
        <br><br><strong>Por favor espere...</strong><br><small>` + mensaje + `</small></h4>
      </div>`,
      toast: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
